import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Navbar.css';

function NavigationBar() {
  const [expanded, setExpanded] = useState(false);

  const closeNav = () => setExpanded(false);

  return (
    <Navbar expand="lg" className="site-navbar" expanded={expanded}>
      <Container>
        <NavLink to="/" className="navbar-brand" onClick={closeNav}>
          Solutions
        </NavLink>
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(!expanded)}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavLink to="/framework" className="nav-link fw-semibold" onClick={closeNav}>
              Framework
            </NavLink>
            <NavLink to="/services" className="nav-link fw-semibold" onClick={closeNav}>
              Services
            </NavLink>
            <NavLink to="/contact" className="nav-link fw-semibold" onClick={closeNav}>
              Contact
            </NavLink>
            <NavLink to="/talk" className="nav-link talk-now-btn" onClick={closeNav}>
              Talk Now
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
